<template>
    <div class="row" v-if="! showAddRecord && refereeRecords && refereeRecords.length > 0">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="refereeRecords"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width>Name</th>
                            <th width>Occupation</th>
                            <th width>Position</th>
                            <th width>Tel</th>
                            <!-- <th width>Folio No</th> -->
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index+1}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.name }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.occupation }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.position }}
                        </td>
                        <td>
                            {{ row.phone }}
                        </td>
                        <!-- <td>
                            {{ row.folio_number ? row.folio_number : 'N/A' }}
                        </td> -->
                        <td>
                            <base-button
                                type="danger" size="sm"
                                @click="$emit('deleteRefereeRecord', row.id)"
                            >
                                <i class="fa fa-trash"></i> Remove
                            </base-button>
                        </td>

                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                     @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'AssessmentRefereeData',
        props: ["refereeRecords", "showAddRecord", "pagination", "hasPagination", "paginate"],
        filters: {
            getDateFormat(value) {
                return moment(value).format('Do MMM, YYYY');
            }
        }
    }
</script>